<!--杭州东杰定制看板-->
<template>
	<div style="padding:0 10px;width: calc(100% - 20px);background: #092f66;" class="custom-scrollbar">
		<div class="flexCenter" style="margin-top: 10px;">
			<div style="width: 22%;">
				<!-- 站点概况 -->
				<unitInfo style="width: 100%;height: 390px;"></unitInfo>
				<!-- 负荷概况 -->
				<loadInfo style="width: 100%;height: 260px;margin-top: 10px;"></loadInfo>
			</div>
			<!-- 地图 -->
			<div style="width: calc(56% - 20px);height: 660px; margin: 0 10px;position: relative;" class="flexCenter">
				<webMap ref="mapBean" style="width: 100%;height: 100%;" v-show="mapType == 0" @updateMap="loadBoundary"> </webMap>
				<div class="svgMap" v-show="mapType == 1">
					<p style="left: 25%;top: 45%;" class="mapText">瓶窑片区</p>
					<p style="left: 64%;top: 36%;" class="mapText">塘栖片区</p>
					<p style="left: 80%;top: 30%;" class="mapText">东湖片区</p>
					<p style="left: 80%;top: 46%;" class="mapText">南苑片区</p>
					<p style="left: 33%;top: 68%;" class="mapText">科技城片区</p>
					<embed src="./static/杭州东杰定制/看板/地图/1.svg" type="image/svg+xml" style="position: absolute; left: 5%; top: 16%; width: 61%;" @click="mapType = 0"/>
					<embed src="./static/杭州东杰定制/看板/地图/2.svg" type="image/svg+xml" style="position: absolute; left: 53.8%; top: 24%; width: 28%;" />
					<embed src="./static/杭州东杰定制/看板/地图/3.svg" type="image/svg+xml" style="position: absolute; left: 75%; top: 22.5%; width: 19%" />
					<embed src="./static/杭州东杰定制/看板/地图/4.svg" type="image/svg+xml" style="position: absolute; left: 77%; top: 35.3%; width: 17%;" />
					<embed src="./static/杭州东杰定制/看板/地图/5.svg" type="image/svg+xml" style="position: absolute; left: 24%; top: 54%; width: 31.5%;" />
					<div style="left: 48%;top: 45%;" class="mapPoint flexCenterColumn">
						<p>{{areaUserCount['瓶窑片区']}}户用户</p>
						<img src="/static/杭州东杰定制/看板/地图/mapPoint.png" alt="">
					</div>
					<div style="left: 65%;top: 41%;" class="mapPoint flexCenterColumn">
						<p>{{areaUserCount['塘栖片区']}}户用户</p>
						<img src="/static/杭州东杰定制/看板/地图/mapPoint.png" alt="">
					</div>
					<div style="left: 78%;top: 33%;" class="mapPoint flexCenterColumn">
						<p>{{areaUserCount['东湖片区']}}户用户</p>
						<img src="/static/杭州东杰定制/看板/地图/mapPoint.png" alt="">
					</div>
					<div style="left: 81%;top: 51%;" class="mapPoint flexCenterColumn">
						<p>{{areaUserCount['南苑片区']}}户用户</p>
						<img src="/static/杭州东杰定制/看板/地图/mapPoint.png" alt="">
					</div>
					<div style="left: 36%;top: 74%;" class="mapPoint flexCenterColumn">
						<p>{{areaUserCount['科技城片区']}}户用户</p>
						<img src="/static/杭州东杰定制/看板/地图/mapPoint.png" alt="">
					</div>
				</div>
				<div class="runDayBox flexCenter">
					<p>安全运行</p>
					<p v-for="i in safetyDate" class="runDayItem">{{i}}</p>
				</div>
				<div class="flexCenter mapCheckBox" v-if="showToggleMapType">
					<p :class="{'isCheck':mapType == 0}" @click="mapType = 0">G I S 图</p>
					<p :class="{'isCheck':mapType == 1}" @click="mapType = 1">区 域 图</p>
				</div>
			</div>

			<div style="width: 22%;">
				<!-- 事件统计 -->
				<eventCountPie style="width: 100%;height: 330px;"></eventCountPie>
				<!-- 运维管理 -->
				<orderCountPie style="width: 100%;height: 320px;margin-top: 10px;"></orderCountPie>
			</div>
		</div>
		<div class="flexBetween" style="margin-top: 10px;">
			<!-- 今日负荷曲线 -->
			<todayLoadCurve style="width: calc(50% - 5px);height: 340px;"></todayLoadCurve>
			<!-- 年用电量 -->
			<yearPowerCurve style="width: calc(50% - 5px);height: 340px;"></yearPowerCurve>
		</div>
	</div>
</template>

<script>
	import unitInfo from '@/page/projectDingZhi/dongjie/unitInfo.vue'
	import loadInfo from '@/page/projectDingZhi/dongjie/loadInfo.vue'
	import todayLoadCurve from '@/page/projectDingZhi/dongjie/todayLoadCurve.vue'
	import yearPowerCurve from '@/page/projectDingZhi/dongjie/yearPowerCurve.vue'
	import eventCountPie from '@/page/projectDingZhi/dongjie/eventCountPie.vue'
	import orderCountPie from '@/page/projectDingZhi/dongjie/orderCountPie.vue'
	import webMap from '@/page/projectDingZhi/dongjie/webMap.vue'
	export default {
		components: {
			unitInfo,
			loadInfo,
			todayLoadCurve,
			yearPowerCurve,
			eventCountPie,
			orderCountPie,
			webMap,
		},
		props: {},
		data() {
			return {
				mapType: 0, //混合0区域1
				areaUserCount: {},
				showToggleMapType:false
			}
		},
		created() {},
		mounted() {
			debugPage = this
			var axios = require('axios')
			axios({
				url: "/static/杭州东杰定制/看板/地图/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				this.areaUserCount = data.areaUserCount
				this.showToggleMapType = data.showToggleMapType
			})
			//分辨率提示
			var nowWidth = window.screen.width
			var nowHeight = window.screen.height
			if (nowWidth != 1920 || nowHeight != 1080) {
				this.$dialogMethod.openAgreeDialog('分辨率不匹配','当前分辨率不是1920*1080，界面可能错位，请修改分辨率至1920*1080！ 笔记本用户请调整缩放为100%（桌面点击右键 => 显示设置 => 缩放）',undefined,undefined,false)
			}
			this.loadBoundary()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			safetyDate() {
				return Math.floor((Date.now() - this.nowUnit.joinTime) / (24 * 3600 * 1000)) + '天'
			},
		},
		watch: {},
		methods: {
			loadBoundary(){}
		}
	}
</script>

<style scoped>
	>>>.titleText {
		padding-top: 10px;
		text-align: center;
		font-weight: bold;
		font-size: 18px;
	}

	>>>p,
	>>>span {
		font-size: .12rem;
		line-height: .16rem;
		color: white;
	}


	.bg {
		background: -moz-linear-gradient(top, #051c4d 0%, #0b3074 100%);
		background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #051c4d), color-stop(100%, #0b3074));
		background: -webkit-linear-gradient(top, #051c4d 0%, #0b3074 100%);
		background: -o-linear-gradient(top, #051c4d 0%, #0b3074 100%);
		background: -ms-linear-gradient(top, #051c4d 0%, #0b3074 100%);
		background: linear-gradient(to bottom, #051c4d 0%, #0b3074 100%);
	}

	.bottomImg {
		width: 80%;
		margin: 5% 10% 0 p10%;
	}

	.runDayBox {
		background-image: url(../../../../public/static/杭州东杰定制/看板/地图/runDayBg.png);
		position: absolute;
		width: 200px;
		height: 50px;
		top: 10px;
		left: 10px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.runDayBox>p {
		font-size: 14px;
		font-weight: bold;
	}

	.runDayBox>p:first-of-type {
		margin-right: 5px;
	}

	.runDayItem {
		background: #2bafec;
		width: 21px;
		padding: 7px 0;
		text-align: center;
		margin: 0 2px;
	}

	.mapCheckBox {
		background-image: url(../../../../public/static/杭州东杰定制/看板/地图/runDayBg.png);
		position: absolute;
		width: 200px;
		height: 50px;
		top: 10px;
		right: 10px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.mapCheckBox>p {
		border: 2px solid #ed7310;
		font-size: 14px;
		font-weight: bold;
		padding: 5px;
		cursor: pointer;
	}

	.mapCheckBox>p:first-of-type {
		border-right: 0;
	}

	.mapCheckBox>p.isCheck {
		background: #ed7310;
	}

	.mapText {
		font-size: 24px;
		font-weight: bold;
		position: absolute;
	}

	.svgMap {
		width: 800px;
		height: 660px;
		position: relative;
		background-image: url(../../../../public/static/杭州东杰定制/看板/地图/mapBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.mapPoint {
		position: absolute;
	}

	.mapPoint>img {
		width: 20px;
		height: 50px;
	}

	.mapPoint>p {
		color: white;
		font-size: 16px;
	}
</style>
